import PropTypes from 'prop-types'

const ThumbAuthor = ({ date }) => {
  const formatedDate = new Date(date).toLocaleDateString('pt-BR')

  const renderDate = () => {
    if (date) {
      return <span className="date">{ formatedDate }</span>
    }

    return null
  }

  return (
    <div className="author">
      {renderDate()}
    </div>
  )
}

ThumbAuthor.propTypes = {
  date: PropTypes.string.isRequired
}

export default ThumbAuthor
